import React, { memo } from "react";

import { IconButton } from "@mui/material";
import Popover from "@mui/material/Popover";
import { colors } from "@zapalacorp/tokens";
import IconWrapperComponent from "Components/IconWrapperComponent/IconWrapperComponent";
import { useTranslation } from "react-i18next";
import { ReactSVG } from "react-svg";

import { TitleWrapper } from "./styles";

const INFOR_CIRCLE = require("Assets/icons/info-circle.svg");

interface IMoreOptionOrderProps {
  options?: string[] | any;
  moreOptionsTitle?: string;
}

const MoreOptionOrderComponent = (props: IMoreOptionOrderProps) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const { t: translate } = useTranslation();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event?.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  if (props?.options?.length === 0) return <> </>;
  if (props?.options?.length === 1)
    return (
      <TitleWrapper
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "start",
          gap: "8px",
        }}
      >
        {props?.options?.join("")}
      </TitleWrapper>
    );

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "start",
        gap: "4px",
      }}
    >
      <TitleWrapper>{props?.moreOptionsTitle || translate("groupage")}</TitleWrapper>
      <IconButton onClick={handleClick}>
        <IconWrapperComponent
          style={{
            background: anchorEl && colors.brandBlue500,
            borderRadius: "50%",
            color: anchorEl && colors.white,
          }}
        >
          <ReactSVG src={INFOR_CIRCLE} />
        </IconWrapperComponent>
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
        sx={{
          "& .MuiPaper-rounded": {
            borderRadius: "12px",
          },
        }}
      >
        <div
          style={{
            display: "flex",
            padding: "12px 16px 12px 16px",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "4px",
            borderRadius: "12px",
          }}
        >
          {props?.options?.length > 0 &&
            props?.options?.map((item: string | any) => (
              <TitleWrapper key={item}>{item}</TitleWrapper>
            ))}
        </div>
      </Popover>
    </div>
  );
};

export default memo(MoreOptionOrderComponent);
